/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef } from "../types";
import { nearestColorName } from "../utils/colorName";

export const ColorViewer = defineComponent({
  name: "ColorViewer",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: String as PropType<string | null>, default: null },
  },
  setup(props) {
    return () => {
      const color = props.value;
      if (!color) return <span class="lg-cell-text lg-cell-placeholder">—</span>;

      const label = nearestColorName(color) ?? color;

      return (
        <span class="lg-cell-color" title={color}>
          <span class="lg-cell-color-swatch" style={{ backgroundColor: color }} />
          <span class="lg-cell-text">{label}</span>
        </span>
      );
    };
  },
});
